import { useState, useEffect, useCallback, useMemo } from "react";
import * as global from '../data/global';
import { MuiMaterials } from "../@index";
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import { createTheme } from '@mui/material/styles';

export const HistorySlider = (props) => {
    const [value, setValue] = useState(props.value?.value || 1);
    const [forceUpdate, setForceUpdate] = useState(0);

    // Helper function to get theme-aware colors (reads directly from global.gw.theme)
    const getThemeColor = useCallback((lightColor, darkColor) => {
        if (global.gw.theme === 'light') {
            return lightColor;
        }
        return darkColor;
    }, []);

    // Listen for theme changes - only trigger re-render when theme actually changes
    useEffect(() => {
        const handleThemeChange = () => {
            setForceUpdate(prev => prev + 1);
        };
        window.addEventListener('themeChanged', handleThemeChange);
        return () => window.removeEventListener('themeChanged', handleThemeChange);
    }, []);

    const historySliderTheme = useMemo(() => {
        const isLight = global.gw.theme === 'light';
        return createTheme({
    components: {
        // Name of the component
        MuiSlider: {
            defaultProps: {
                //disableRipple: true,
                orientation: "vertical",
            },
            styleOverrides: {
                //valueLabel: ({ ownerState, theme }) => ({
                //    ...(ownerState.orientation === 'horizontal' && {
                //        backgroundColor: 'transparent',
                //        //display: "none",
                //        color: "rgba(244, 204, 142, 0.38);",
                //    }),
                //}),
                markLabel: (o, t) => ({
                    ...({
                        //color: '#b3b3b3',
                        //fontFamily: "'Montserrat', sans-serif",
                        //fontWeight: 700,
                        //marginTop: 6,
                        //display: "none",
                        //transform: "translate(-180px, 18px)",
                        left: "33px !important",
                        color: isLight ? "rgba(51, 51, 51, 1)" : "rgba(244, 204, 142, 1)",
                        fontSize: "16px",
                        padding: "0px",
                        display: "none",
                        margin: "auto",
                        textAlign: "center",
                        lineHeight: "1000px",
                    }),
                }),
                mark: (o, t) => ({
                    ...({
                        color: isLight ? "#333333" : "white",
                        width: "5px",
                        height: "5px",
                        fontSize: "10px",
                        //fontFamily: "'Montserrat', sans-serif",
                        //fontWeight: 700,
                        //marginTop: 6,
                        //display: "none",
                    }),
                }),
                thumb: (o, t) => ({
                    ...({
                        size: "small"
                    }),
                }),
                track: (o, t) => ({
                    ...({
                        //display: "none"
                    }),
                }),
                rail: (o, t) => ({
                    ...({
                        opacity: 1
                    }),
                }),
            }
        }
    }
    });
    }, [forceUpdate]);

    const datePickerTheme = useMemo(() => {
        const isLight = global.gw.theme === 'light';
        return createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: isLight ? '#e0e0e0' : '#2d2d2d',
                    color: isLight ? 'rgb(51, 51, 51)' : 'rgb(244, 204, 142)',
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeMedium: {
                    color: isLight ? 'rgb(51, 51, 51)' : 'rgb(244, 204, 142)'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: isLight ? '#ffffff' : '#2d2d2d',
                    color: isLight ? 'rgb(51, 51, 51)' : 'rgb(244, 204, 142)'
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: isLight ? '#ffffff' : '#2d2d2d',
                    color: isLight ? 'rgb(51, 51, 51)' : 'rgb(244, 204, 142)',
                    ...(isLight && {
                        '&:not(.MuiInputLabel-shrink)': {
                            top: '50%',
                            transform: 'translateY(-50%)',
                            left: '14px',
                        },
                    }),
                },
                shrink: {
                    top: isLight ? '8px' : undefined,
                },
            }
        }
    }
    });
    }, [forceUpdate]);

    const setTemperatureLabel = async (s) => {
        if (global.gw.selectedSite.selectedMark.sensorHistories && global.gw.selectedSite.selectedMark.sensorHistories.length > 0) {
            //let sensorHistory = mark.sensorHistories.filter(x => x.sensorId === s.sensorId)[0];
            //if (sensorHistory) {
            //    global.updateSensorTemperature(s.binId, s.cableId, s.sensorId, sensorHistory.temperature);
            //    s.sensorValueString = sensorHistory.temperature;
            //    s.sensorValueNumber = +sensorHistory.temperature;
            //}
            let sensorHistory = null;
            //let testmark = global.gw.selectedSite.selectedMark;
            for (let i = 0; i < global.gw.selectedSite.selectedMark.sensorHistories.length; i++) {
                sensorHistory = global.gw.selectedSite.selectedMark.sensorHistories[i];
                if (sensorHistory.sensorId == s.sensorId ||
                    (sensorHistory.sensorName && s.sensorName && sensorHistory.sensorName === s.sensorName)) {
                    global.updateSensorTemperature(s.binId, s.cableId, s.sensorId, sensorHistory.temperature, sensorHistory.lastTemperature);
                    s.sensorValueString = sensorHistory.temperature;
                    s.sensorValueNumber = +sensorHistory.temperature;
                    s.sensorLastValueString = sensorHistory.lastTemperature;
                    s.sensorLastValueNumber = +sensorHistory.lastTemperature;
                    break;
                }
            }
        }
    }

    useEffect(() => {
        setValue(props.value.value);
        handleSliderDateChange(props.value.value);
        handleDateSliderChangeCommited();

        let val = window.document.querySelectorAll(`[aria-label="Always Visible"]`)[0];
        if (val) {
            val.value = `${props.value.value}`;
            val.ariaValueNow = `${props.value.value}`;
            let mark = Array.from(window.document.getElementsByClassName("MuiSlider-mark")).filter(x => parseInt(x.attributes["data-index"].value) + 1 === props.value.value)[0];
            if (mark) {
                val.parentElement.style.bottom = mark.style.bottom;
            }
        }
    }, [props.value.value]);

    const handleSliderDateChange = (v) => {
        //let markss = global.gw.selectedSite.marks;
        global.gw.selectedSite.selectedMark = global.gw.selectedSite.marks.filter(x => x.value == v)[0];
        if (global.gw.selectedSite.selectedMark) {
            let dateLabel = window.document.getElementsByClassName("dateLabel")[0];
            if (dateLabel) {
                dateLabel.children[0].innerHTML = global.gw.selectedSite.selectedMark.label;
            }

            let markLabels = window.document.getElementsByClassName("MuiSlider-markLabel");
            if (markLabels) {
                Array.from(markLabels).map((markLabel, i) => {
                    if (global.gw.selectedSite.selectedMark.value === i + 1) {
                        //markLabel.style.color = "rgba(244, 204, 142, 1)";
                        //markLabel.style.zIndex = "10";
                        //markLabel.style.padding = "6px";
                        markLabel.style.display = "flex";
                        markLabel.classList.add("mark-selected");
                    }
                    else {
                        //markLabel.style.color = "rgba(255, 193, 78, 0.85)";
                        //markLabel.style.zIndex = "0";
                        //markLabel.style.padding = "1px 6px";
                        markLabel.style.display = "none";
                        markLabel.classList.remove("mark-selected");
                    }
                });
            }

            //setSliderValue(global.gw.selectedSite.selectedMark.value);
            //setSliderDefaultValue(1);
        }
    }

    const handleDateSliderChangeCommited = async () => {
        //let selmark = global.gw.selectedSite.selectedMark;
        let testGlobal = global.gw;
        if (global.gw.selectedSite.selectedMark) {
            if (global.gw.selectedSite.layoutSensors && global.gw.selectedSite.layoutSensors.length > 0) {
                for (const s of global.gw.selectedSite.layoutSensors) {
                    await setTemperatureLabel(s);
                }
            }

            if (global.gw.selectedSite.isObjectSelected) {
                global.setUnselectedCablesOff({ preserveToggleState: true });
            }
            else {
                if (global.gw.selectedSite.isCablesOff) {
                    global.setAllBinsTextColorOn();
                }
                else {
                    global.setAllBinsTextColorOff();
                }
            }

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (typeof global.renderSiteBinLevels === "function") {
                        global.renderSiteBinLevels();
                    }
                });
            });
        }
    }

    return (
        <MuiMaterials.ThemeProvider theme={historySliderTheme} key={`historyslider-theme-${global.gw.theme}-${forceUpdate}`}>
            <MuiMaterials.Slider
                key={`historyslider-${global.gw.theme}-${forceUpdate}`}
                className={props.className}
                aria-label="Always Visible"
                value={value}
                //defaultValue={value}
                //getAriaValueText={valuetext}
                step={1}
                marks={props.marks ?? []}
                min={1}
                max={Math.max(1, (props.marks ?? []).length)}
                valueLabelDisplay="off"
                size="small"
                sx={{
                    color: getThemeColor('#333333', '#f4cc8e'),
                    fontSize: "12px",
                    padding: "0px 0px 0px 30px",
                    margin: "0px",
                }}

                onChange={(e, v) => {
                    setValue(v);
                    handleSliderDateChange(v);
                    
                    // Update marker position visually
                    let val = window.document.querySelectorAll(`[aria-label="Always Visible"]`)[0];
                    if (val) {
                        val.value = `${v}`;
                        val.ariaValueNow = `${v}`;
                        let mark = Array.from(window.document.getElementsByClassName("MuiSlider-mark")).filter(x => parseInt(x.attributes["data-index"].value) + 1 === v)[0];
                        if (mark) {
                            val.parentElement.style.bottom = mark.style.bottom;
                        }
                    }
                }}
                onChangeCommitted={handleDateSliderChangeCommited}
            />
        </MuiMaterials.ThemeProvider>
    );
}

export default HistorySlider;